import { IsNotEmpty, IsUUID } from 'class-validator';

export class PepBatchSignEventDto {
  @IsNotEmpty()
  @IsUUID()
  event_id: string;
}
